/* eslint react/prop-types: off */
import {
  map,
  findIndex,
  isNull,
  filter
} from 'lodash'
import moment from 'moment'
import {
  ContentSectionBlock,
  Table
} from 'camino-react'
import React from 'react'

import EventModal from '../../Dispatcher/EventModal'
import { handlers } from '../../Dispatcher/handlers'
import { resourcesContainer } from '../../Dispatcher/containers'

import TicketTimesheetCreate from 'Components/Tickets/TicketTimesheets/TicketTimesheetCreate'
import { cloudhelpPatch } from 'Utilities/CloudHelp'

export default class WorkEventsInformation extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      ...props,
      timesheetOpen: false,
      displayForm: false,
      dispatcherEvent: {},
      processingEvent: false
    }
    this.handlers = handlers.bind(this)
  }

  componentDidMount () {
    handlers.getResourcesForSelect()
  }

  setWorkEventCompleted (eventId, isCompleted) {
    this.updateWorkEvent(eventId, true, isCompleted)

    cloudhelpPatch(`/api/dispatcher/events/${eventId}`, { task: { completed_at: isCompleted ? new Date() : null } })
      .finally(() => {
        this.updateWorkEvent(eventId, false, isCompleted)
      })
  }

  updateWorkEvent (eventId, loadingState, isCompleted) {
    this.setState((prevState) => {
      const newEvents = [...prevState.events]
      const completedEventIndex = findIndex(newEvents, event => event.id === eventId)
      const completedEvent = {
        ...newEvents[completedEventIndex],
        loading: loadingState,
        isCompleted
      }

      newEvents[completedEventIndex] = completedEvent

      return { events: newEvents }
    })
  }

  convertTask (task) {
    const timesheet = {
      start_time: task.start,
      end_time: task.end,
      description: task.description,
      taskId: task.id
    }

    this.setState({ timesheet, timesheetOpen: true })
  }

  generateDispatcherEvent () {
    const { ticket, current_user: currentUser } = this.state
    const { formSource } = this.props
    const start = moment().add(1, 'hour').startOf('hour')
    const isDispatcher = formSource === 'Dispatcher'

    const dispatcherEvent = {
      title: isDispatcher && ticket.title,
      description: isDispatcher && ticket.description,
      start: start.format(),
      end: start.add(15, 'minutes').format(),
      ticket,
      resourceId: currentUser.id
    }

    this.setState({ displayForm: true, dispatcherEvent })
  }

  handleEdit (task) {
    this.setState({ showEvent: task })
  }

  render () {
    const {
      watcherOptions,
      current_user: currentUser
    } = this.props

    const {
      events,
      timesheetOpen,
      ticket,
      serviceGroups,
      defaultServiceGroupId,
      hasManagedServiceGroup,
      ticket_statuses,
      timesheet,
      displayForm,
      dispatcherEvent,
      processingEvent,
      resources,
      ticketsForSelect,
      showEvent
    } = this.state

    const data = map(events, (event) => {
      const { isCompleted, loading } = event

      return ({
        ...event,
        completed: {
          value: isCompleted,
          onValue: completed => this.setWorkEventCompleted(event.id, completed),
          disabled: loading
        },
        action_ellipsis: [
          { text: 'Convert to Timesheet', onClick: () => this.convertTask(event) },
          { text: 'Edit', onClick: () => this.handleEdit(event) }
        ]
      })
    })

    const columns = [
      {
        text: 'Completed',
        type: 'checkbox'
      },
      {
        text: 'Title',
        accessor: 'title',
        Cell: row => (
          <p style={{ margin: '0' }}>
            {row.value}
            <br />
            {row.original.description}
          </p>
        )
      },
      {
        text: 'Assigned To',
        accessor: 'ownerName'
      },
      {
        text: 'Start',
        type: 'datetime_alt'
      },
      {
        text: 'End',
        type: 'datetime_alt'
      },
      {
        text: 'Actions',
        accessor: 'action_ellipsis',
        type: 'action_ellipsis'
      }
    ]

    return (
      <ContentSectionBlock
        title="Ticket Tasks"
        actions={[
          {
            text: <div className="duration-300 hover:text-blue-700">Add Task</div>,
            onClick: () => this.generateDispatcherEvent()
          }
        ]}
      >
        <Table
          data={data}
          columns={columns}
          localStoragePrefix="TicketShowTicketTasks"
        />
        <TicketTimesheetCreate
          open
          title="New Ticket Timesheet"
          url={`/api/tickets/${ticket.id}/timesheets.json`}
          method="post"
          onClose={() => this.setState({ timesheetOpen: false })}
          regionId={ticket.region_id}
          modalOpen={timesheetOpen}
          serviceGroups={serviceGroups}
          defaultServiceGroupId={defaultServiceGroupId}
          hasManagedServiceGroup={hasManagedServiceGroup}
          ticketStatuses={ticket_statuses}
          ticketId={ticket.id}
          reviewed={!isNull(ticket.reviewed_at)}
          timesheet={timesheet}
          contactName={ticket.contact_name}
          ccOptions={watcherOptions}
        />

        {displayForm && (
          <EventModal
            onClose={() => this.setState({ displayForm: false })}
            event={dispatcherEvent}
            onSubmitEvent={handlers.dispatcher_event_onSubmit}
            currentUser={currentUser}
            processingEvent={processingEvent}
            formSource="TicketShow"
            resourcesForSelect={filter(resources.resourceBar, resource => resource.type === 'user')}
            ticketsForSelect={ticketsForSelect}
          />
        )}

        {showEvent && (
          <EventModal
            onClose={handlers.dispatcher_event_onClose}
            event={showEvent}
            onSubmitEvent={handlers.dispatcher_event_onSubmit}
            onDeleteEvent={handlers.dispatcher_event_onDelete}
            resourcesForSelect={filter(resources.resourceBar, resource => resource.type === 'user')}
            currentUser={currentUser}
            processingEvent={processingEvent}
            ticketsForSelect={ticketsForSelect}
            formSource="TicketShow"
          />
        )}
      </ContentSectionBlock>
    )
  }
}

WorkEventsInformation.defaultProps = {
  resources: resourcesContainer,
  resourcesEndpoint: '/api/dispatcher/resources',
  showEvent: null
}
